function tipErr(msg) {
  let txt = msg || '服务端出错...';
  if (txt.length < 16) {
    vant.Toast.fail({
      message: txt,
      duration: 3000,
    });
  } else {
    vant.Dialog.alert({
      message: txt,
      confirmButtonText: '我知道了',
    });
  }
}
app.http.instance.interceptors.response.use(function (response) {
  if (response.status === 200) {
    try {
      const dataJSON = JSON.stringify(response.data);
      const transData = dataJSON.replace(/（\u200b\u200b(已离职|已删除)\u200b\u200b）/g, '');
      response.data = JSON.parse(transData);
    } catch (e) {
      // if (window.Sentry) {
      //   Sentry.captureMessage(
      //     JSON.stringify({
      //       url: response.config.url,
      //       params: response.data,
      //       result: e,
      //     })
      //   );
      // }
    }
  }
  return response;
})

app.http.instance.interceptors.response.use(
  async result => {
    let res = result.data;
    if (res && res.code != 200) {
      vant.Toast.clear();
      if (res.code === 401) {
        await vant.Dialog.alert({
          message: res.msg || '未登录或登录超时',
        });

        // 临时增加脸到功能过期跳转
        if (location.hash.indexOf('#/face/') === 0) {
          app.parent.loginFace();
        } else {
          app.parent.login();
        }
      } else if (res.code <= 60000) {
        tipErr(res.msg);
        // if (window.Sentry) {
        //   Sentry.captureMessage(
        //     JSON.stringify({
        //       url: result.config.url,
        //       params: result.config.data,
        //       result: result.data,
        //     })
        //   );
        // }
        return Promise.reject(res);
      }
    }

    return res;
  },
  err => {
    vant.Toast.clear();
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误';
          break;
        case 401:
          err.message = '授权失败，请检查token';
          break;
        case 403:
          err.message = '拒绝访问';
          break;
        case 404:
          err.message = `请求${err.response.config.url
            .split('/')
            .pop()
            .replace(/\.html/, '')}接口出错`;
          break;
        case 408:
          err.message = '请求超时';
          break;
        case 429:
          err.message = '操作过于频繁，请等待1-3秒再试~'
          break
        case 500:
          err.message = '服务器内部错误';
          break;
        case 501:
          err.message = '服务未实现';
          break;
        case 502:
          err.message = '网关错误';
          break;
        case 503:
          err.message = '服务不可用';
          break;
        case 504:
          err.message = '网关超时';
          break;
        case 505:
          err.message = 'HTTP版本不受支持';
          break;
        default:
      }

      tipErr(err.message || '接口请求错误...');
    }

    // if (window.Sentry) {
    //   Sentry.captureMessage(err);
    // }
    return Promise.reject(err);
  }
);

// console.log(">>>>>>>>>>>>>>>>");
// console.log(process.env.NODE_ENV);

// 根据环境区分接口前缀
// let apiPre = ""
// if (process.env.NODE_ENV == "development") {
//     apiPre = ""
// } else if (process.env.NODE_ENV == "production") {
//     apiPre = "/api"
// }

function transUrl(url) {
  var inter = {
    // server: `${apiPre}`,
    server: `/api`,
    mock: '/mock',
    json: '/json',
  };

  var ip = app.tool.parseQuery().ip,
    proxy = ip ? `/${ip}` : '';

  if (ip === 'json') {
    url = inter[ip] + url;
  } else {
    url = proxy + inter.server + url;
  }
  return url;
}

app.http.instance.interceptors.request.use(
  config => {
    config.url = transUrl(config.url);

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
